import BuildingSearch from 'components/utility/building_search'
import React, { useState } from 'react'

export default function PropertySelection({ onSelect }) {
  const [isEmptyBuilding, setIsEmptyBuilding] = useState(false)

  return (
    <div
      style={{ marginTop: '4.8rem' }}
      className="property-selection dome-d-flex dome-flex-column dome-gap18 dome-full-width"
    >
      <span className="dome-h4 dome-color-dark-grey">choose a property</span>
      <BuildingSearch
        show_magnifying_glass={true}
        placeholderText="find your property"
        classes={{
          iconClass: 'fa-thin fa-magnifying-glass fa-lg',
          containerClass: 'property-container',
          inputClass: 'property-container-search',
          buildingPossibilities: 'property-container-building-list',
        }}
        url="/questionnaire/buildings/lookup_buildings"
        onSelect={(b) => (b?.id ? onSelect(b) : setIsEmptyBuilding(false))}
        onChange={(b) => setIsEmptyBuilding(b.length === 0)}
      />
      {isEmptyBuilding && (
        <div className="property-container-building-list-empty">
          <span className="dome-p2 dome-color-dark-grey dome-text-w300">
            We’re sorry, questionnaires are not currently offered for this property.
          </span>
        </div>
      )}
    </div>
  )
}
